(function () {
  'use strict';
  if (window.TKHolidayUI) { window.TKHolidayUI.mount(document); return; }
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
  const text = (root, selector, value) => root.querySelectorAll(selector).forEach(node => { node.textContent = value; });
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  function update(scope, option, pushUrl = false) {
    scope.dataset.variant = option.id;
    text(scope, '[data-price]', money(option.price));
    text(scope, '[data-value]', money(option.value));
    text(scope, '[data-save]', money(option.value - option.price));
    scope.querySelectorAll('[data-card-contents]').forEach(node => {
      const contents = document.createDocumentFragment();
      option.components.forEach((component, index) => {
        if (index) contents.append(document.createTextNode(' '));
        const part = document.createElement('span');
        part.className = 'tk-holiday-card__component-text';
        part.textContent = component.name + ' ' + component.size + (index < option.components.length - 1 ? ' +' : '');
        contents.append(part);
      });
      node.replaceChildren(contents);
    });
    scope.querySelectorAll('[data-shipping-status]').forEach(node => { node.textContent = option.price >= 7000 ? node.dataset.qualifiedLabel : node.dataset.thresholdLabel; });
    scope.querySelectorAll('[data-shipping-check]').forEach(node => { node.hidden = option.price < 7000; });
    text(scope, '[data-holiday-gift-status]', option.price >= 9000 ? 'Included free' : 'Free at $90+');
    scope.querySelectorAll('[data-free-shipping-badge]').forEach(node => { node.hidden = option.price < 7000; });
    scope.querySelectorAll('[data-gift-badge]').forEach(node => { node.hidden = option.price < 9000; });
    scope.querySelectorAll('[data-holiday-size]').forEach(input => { input.checked = input.value === option.size; });
    const cardImage = scope.querySelector('[data-card-image]');
    if (cardImage) cardImage.src = option.card;
    const stickyImage = scope.querySelector('[data-sticky-image]');
    if (stickyImage) stickyImage.src = option.card;
    const essence = option.components.find(component => component.key.startsWith('essence'));
    text(scope, '[data-sticky-size]', essence ? essence.size : option.components.length + ' full-size products');
    scope.querySelectorAll('[data-product-link]').forEach(link => {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('variant', option.id);
      link.href = url.pathname + url.search;
    });
    scope.querySelectorAll('[data-variant-input]').forEach(input => { input.value = option.id; });
    const form = scope.querySelector('form');
    if (form) {
      const unavailable = option.available === false;
      scope.querySelectorAll('[data-holiday-add]').forEach(add => {
        add.disabled = unavailable || form.dataset.tkPending === 'true';
        add.dataset.unavailable = String(unavailable);
      });
      text(scope, '[data-add-label]', unavailable ? 'Sold out' : 'Add to cart');
    }
    scope.querySelectorAll('[data-component]').forEach((row, index) => {
      const c = option.components[index];
      if (!c) return;
      text(row, '[data-component-name]', c.name);
      text(row, '[data-component-size]', c.size);
      text(row, '[data-component-price]', money(c.price));
      row.querySelector('[data-component-image]').src = c.image;
      const tab = scope.querySelector('[data-ingredient-tab="' + index + '"]');
      if (tab) {
        const size = document.createElement('span');
        size.className = 'tk-holiday__ingredient-size';
        size.textContent = c.size;
        tab.replaceChildren(document.createTextNode(c.name + ' '), size);
      }
      const panel = scope.querySelector('[data-ingredient-panel="' + index + '"]');
      if (panel) text(panel, '[data-ingredient-title]', c.title + ' · ' + c.size);
    });
    scope.querySelectorAll('[data-gallery-slide]').forEach((picture, index) => {
      if (picture.tagName !== 'PICTURE') return;
      const asset = option.gallery[index];
      if (!asset) return;
      const img = picture.querySelector('img');
      img.src = asset.src;
      img.alt = asset.alt;
      const source = picture.querySelector('source');
      if (source) source.srcset = asset.mobile;
    });
    scope.querySelectorAll('[data-art-option]').forEach(node => { node.hidden = node.dataset.artOption !== (option.size || '100ml'); });
    const giftNote = scope.querySelector('[data-set-gift-note]');
    if (giftNote && scope.dataset.key !== 'care') giftNote.hidden = option.price < 9000;
    if (pushUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', option.id);
      history.replaceState(history.state, '', url);
    }
  }

  function initializePdp(root, bundle) {
    if (!bundle) return;
    const setFromUrl = () => {
      const selected = new URL(location.href).searchParams.get('variant');
      update(root, bundle.options.find(o => o.id === selected) || bundle.options[0]);
    };
    setFromUrl();
    window.addEventListener('popstate', setFromUrl);
    root.addEventListener('change', event => {
      if (!event.target.matches('[data-holiday-size]')) return;
      const option = bundle.options.find(o => o.size === event.target.value);
      if (option) update(root, option, true);
    });
    const info = root.querySelector('.tk-holiday__info');
    const measureInfo = () => info.style.setProperty('--holiday-info-height', info.offsetHeight + 'px');
    measureInfo();
    const infoObserver = new ResizeObserver(measureInfo);
    infoObserver.observe(info);
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) infoObserver.disconnect(); });
    const gallery = root.querySelector('[data-holiday-gallery]');
    const dots = [...root.querySelectorAll('[data-gallery-dot]')];
    const counter = root.querySelector('[data-gallery-count]');
    const mobile = matchMedia('(max-width: 749px)');
    const showSlide = index => gallery.scrollTo({ left: gallery.clientWidth * index, behavior: reduceMotion() ? 'instant' : 'smooth' });
    dots.forEach((dot, index) => dot.addEventListener('click', () => showSlide(index)));
    let frame;
    function updateGalleryPosition() {
      const index = Math.max(0, Math.min(dots.length - 1, Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth))));
      dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(dots.length).padStart(2, '0');
      counter.setAttribute('aria-label', 'Image ' + (index + 1) + ' of ' + dots.length);
    }
    gallery.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateGalleryPosition);
    }, { passive: true });
    const galleryObserver = new ResizeObserver(updateGalleryPosition);
    galleryObserver.observe(gallery);
    updateGalleryPosition();
    gallery.addEventListener('keydown', event => {
      if (!matchMedia('(max-width: 749px)').matches || !['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
      event.preventDefault();
      const current = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
      showSlide(Math.max(0, Math.min(dots.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1))));
    });
    const sticky = root.querySelector('[data-holiday-sticky]');
    const mainAdd = info.querySelector('[data-holiday-add]');
    function updateSticky() {
      const button = mainAdd.getBoundingClientRect();
      const mainVisible = button.bottom > 0 && button.top < window.innerHeight;
      sticky.hidden = !mobile.matches || info.getBoundingClientRect().top >= window.innerHeight || mainVisible;
    }
    const stickyObserver = new IntersectionObserver(updateSticky);
    stickyObserver.observe(mainAdd);
    stickyObserver.observe(info);
    mobile.addEventListener('change', updateSticky);
    updateSticky();
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      galleryObserver.disconnect();
      stickyObserver.disconnect();
      mobile.removeEventListener('change', updateSticky);
      window.removeEventListener('popstate', setFromUrl);
      cancelAnimationFrame(frame);
    });
    const dialog = root.querySelector('[data-ingredients-dialog]');
    const opener = root.querySelector('[data-open-ingredients]');
    opener.addEventListener('click', () => { dialog.showModal(); document.documentElement.classList.add('tk-holiday-modal-open'); });
    root.querySelector('[data-close-ingredients]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const r = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('tk-holiday-modal-open'); opener.focus({ preventScroll: true }); });
    const tabs = [...dialog.querySelectorAll('[data-ingredient-tab]')];
    function selectTab(index, focus = false) {
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      dialog.querySelectorAll('[data-ingredient-panel]').forEach((panel, i) => { panel.hidden = i !== index; });
      dialog.querySelector('.tk-holiday__ingredient-panels').scrollTop = 0;
      if (dialog.open && matchMedia('(max-width: 749px)').matches) tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (focus) tabs[index].focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(index));
      tab.addEventListener('keydown', event => {
        if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        selectTab(next, true);
      });
    });

  }

  function initializeCollection(root, bundles) {
    const cards = [...root.querySelectorAll('[data-holiday-card]')];
    cards.forEach(card => {
      const bundle = bundles.find(b => b.key === card.dataset.key);
      if (!bundle) return;
      update(card, bundle.options[0]);
      card.addEventListener('change', event => {
        if (!event.target.matches('[data-holiday-size]')) return;
        const option = bundle.options.find(o => o.size === event.target.value);
        if (option) update(card, option);
      });
    });
    const grid = root.querySelector('[data-holiday-grid]');
    const editorial = root.querySelector('[data-holiday-editorial]');
    const mobile = matchMedia('(max-width: 749px)');
    let filter = 'all';
    function arrange() {
      const visible = cards.filter(card => filter === 'all' || card.dataset.category === filter);
      cards.forEach(card => { card.hidden = !visible.includes(card); });
      const insertion = mobile.matches ? (visible.length >= 3 ? 2 : 1) : Math.min(2, visible.length);
      if (visible[insertion - 1]) visible[insertion - 1].after(editorial);
      grid.dataset.filter = filter;
      editorial.querySelector('[data-editorial-model]').hidden = ['little', 'complete'].includes(filter);
      editorial.querySelector('[data-editorial-stocking]').hidden = !['little', 'complete'].includes(filter);
    }
    root.querySelectorAll('[data-gift-filter]').forEach(button => button.addEventListener('click', () => {
      filter = button.dataset.giftFilter;
      root.querySelectorAll('[data-gift-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      arrange();
    }));
    mobile.addEventListener('change', arrange);
    arrange();
  }

  function mount(container) {
    container.querySelectorAll('[data-holiday-root]').forEach(root => {
      if (root.dataset.initialized) return;
      const json = root.querySelector('[data-holiday-data]');
      if (!json) return;
      let bundles;
      try { bundles = JSON.parse(json.textContent); } catch { return; }
      root.dataset.initialized = 'true';
      if (root.dataset.kind === 'collection') initializeCollection(root, bundles);
      else initializePdp(root, bundles.find(b => b.key === root.dataset.key));
    });
  }
  window.TKHolidayUI = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true }); else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
